import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home/'

Vue.use(Router)

export default new Router({
    routes: [
        {
            path: '/',
            name: 'home',
            component: Home
        },
        {
            path: '/quiz',
            name: 'quiz',
            props: true,
            component: import_vue('quiz')
        },
        {
            path: '/result',
            name: 'result',
            props: true,
            component: import_vue('result')
        }
        
    ]
})


function import_vue(path) {
    return () => import("./views/" + path)
}